import { post } from './http'

//获取体测项目得分统计
export function getItemScoreInfo(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getItemScoreInfo', {
    seasonId: seasonId,
  })
}

//获取本期体测最好成绩
export function getCurrentMaxScore(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getCurrentMaxScore', {
    seasonId: seasonId,
  })
}

//获取近十四天参测人数
export function getCurDatePersonNum() {
  return post('/tyapi/pc/HealthCockpit/getCurDatePersonNum', {})
}

//获取本期参测人数
export function getCurrentPersonNum(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getCurrentPersonNum', {
    seasonId: seasonId,
  })
}

//获取本期合格率
export function getCurrentPassRate(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getCurrentPassRate', {
    seasonId: seasonId,
  })
}
//获取各学院合格率
export function getCollegePassRate(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getCollegePassRate', {
    seasonId: seasonId,
  })
}
//获取近五年合格率
export function getCurrentFiveYearPassRate() {
  return post('/tyapi/pc/HealthCockpit/getCurrentFiveYearPassRate', {})
}
//获取入场信息
export function getEntranceInfo() {
  return post('/tyapi/pc/HealthCockpit/getEntranceInfo', {})
}

//获取本期体测优秀率等
export function getHealthRate(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getHealthRate', {
    seasonId: seasonId,
  })
}
//获取本期各年级数据统计
export function getGradeRate(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getGradeRate', {
    seasonId: seasonId,
  })
}
//获取本期各学院数据统计
export function getCollegeRate(seasonId) {
  return post('/tyapi/pc/HealthCockpit/getCollegeRate', {
    seasonId: seasonId,
  })
}
//获取期次列表
export function getSeasonList() {
  return post('/tyapi/pc/HealthCockpit/getSeasonList', {})
}
